export default "__VITE_PUBLIC_ASSET__fa1a17b9__"